import Litepicker from 'litepicker';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'container', 'selected']

  connect() {
    new Litepicker({
      element: this.element,
      singleMode: this.data.get('mode') == 'single',
      format: 'DD.MM.YYYY',
      lang: 'ru',
      showTooltip: false
    })
  }
}
